import React from "react";
import { CardContent, Card, useTheme, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import CardHeader from "./CardHeader.jsx";
import { faDisplayMedical } from "@fortawesome/pro-solid-svg-icons";
import * as f from "../../../utils/formatter.js";

export default function RiskAllergyCard({ client }) {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Card>
      <CardContent>
        <CardHeader
          title={t("riskAllergies.card.title")}
          color={theme.palette.info.main}
          faIcon={faDisplayMedical}
        />
        <Stack spacing={3} direction="column" sx={{ mb: 3 }}>
          <Typography variant="body1">
            <strong>{t("entity.client.risks")}</strong>
            <br />
            {f.value(client.risks)}
          </Typography>
          <Typography variant="body1">
            <strong>{t("entity.client.medicaments")}</strong>
            <br />
            {f.value(client.medicaments)}
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  );
}
